import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { NavLink, useNavigate } from 'react-router-dom'

import { toast, ToastContainer } from 'react-toastify'

import jwtDecode from 'jwt-decode'
import { CHANGEPASSWORD, REFRESH } from '../../Utils/url.api'
import { fakepostRequest, loadSessionUser } from '../../Services/fake.service'
import { postRequest } from '../../Services/axios.service'
import useUser from '../../Context/hook/useUser'


export const ChangePassword = () => {
    const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm()
    const { login, isAuth, getUser } = useUser()
    const navigate = useNavigate()

    const onSubmit = (async (model) => {
        const sendModel = {
            ...model,
        }
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        await toast.promise(postRequest(CHANGEPASSWORD, sendModel, { headers }), {
            pending: {
                position: 'top-center',
                type: 'default',
                isLoading: true,
                icon: true
            },
        }).then(async (res) => {
            if (res.data.statusCode === 200) {
                toast.success(res.data.message,
                    { autoClose: 2000, position: 'top-center', theme: 'colored' })
                const headers = {
                    Authorization: `Bearer ${loadSessionUser()}`,
                };
                const { data } = await postRequest(REFRESH, {} ,{ headers })
                if (data?.accessToken) {
                    const { accessToken, expireAt } = data
                    login(accessToken, expireAt)
                    navigate(-1)
                }
            }
            else if (res.data.statusCode === 400) {
                toast.error(res.data.message,
                    { autoClose: 2000, position: 'top-center', theme: 'colored' })
            }

        })
    })

    return (
        <div className='text-lg'>
            <ToastContainer />
            <p className='text-4xl text-font-primary font-bold'>
                Cambiar Contraseña
            </p>
            <p className='my-4 text-xl font-medium text-font-muted'>
                Debes cambiar la contraseña por defecto que te enviamos a tu correo
            </p>
            <div className="text-left my-8">
                <form className='custom-form' onSubmit={handleSubmit((data) => onSubmit(data))}>

                    <div className="custom-form__control">
                        <label className='custom-form__label' htmlFor="oldpassword">Contraseña Anterior</label>
                        <input className='custom-form__input' id="oldpassword" type="password" autoComplete='off'
                            {...register('oldpassword',
                                {
                                    required: { message: 'La contraseña es requerida', value: true }
                                })} />
                        <span>
                            {errors.oldpassword?.type === 'required' &&
                                <p className='text-danger' role="alert">{errors.oldpassword?.message}</p>}
                        </span>
                    </div>

                    <div className="custom-form__control">
                        <label className='custom-form__label' htmlFor="newpassword">Nueva Contraseña</label>
                        <input className='custom-form__input' id="newpassword" type="password" autoComplete='off'
                            {...register('newpassword',
                                {
                                    required: { message: 'La contraseña es requerida', value: true },
                                    pattern: {
                                        value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
                                        message: 'La contraseña debe tener al menos 8 dígitos, una letra en mayúscula, un numero y una letra en minúscula ',
                                    }
                                })} />
                        <span>
                            {errors.newpassword?.type === 'required' &&
                                <p className='text-danger' role="alert">{errors.newpassword?.message}</p>}
                            {errors.newpassword?.type === 'pattern' &&
                                <p className='text-warning' role="alert">{errors.newpassword?.message}</p>}
                        </span>
                    </div>

                    <div className="custom-form__control">
                        <label className='custom-form__label' htmlFor="repassword">Repetir Contraseña Nueva</label>
                        <input className='custom-form__input' id="repassword" type="password" autoComplete='off'
                            {...register('repassword',
                                {
                                    required: { message: 'Escriba la contraseña nuevamente', value: true },
                                    validate: {
                                        equal: val => val === getValues('newpassword')
                                    }
                                })} />
                        <span>
                            {errors.repassword?.type === 'required' &&
                                <p className='text-danger' role="alert">{errors.repassword?.message}</p>}
                            {errors.repassword?.type === 'equal' &&
                                <p className='text-danger' role="alert">La contraseñas no coinciden</p>}
                        </span>
                    </div>
                    <div className='w-2/4 mx-auto mt-15'>
                        <button className=' w-full uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 text-white' type="submit">Cambiar Contraseña</button>
                        <span className='text-lg text-font-primary'></span>
                    </div>

                </form>
            </div>
        </div>
    )
}